__turbopack_context__.v({
  "closeButton": "Toaster-module__jDiBjW__closeButton",
  "content": "Toaster-module__jDiBjW__content",
  "description": "Toaster-module__jDiBjW__description",
  "error": "Toaster-module__jDiBjW__error",
  "icon": "Toaster-module__jDiBjW__icon",
  "success": "Toaster-module__jDiBjW__success",
  "title": "Toaster-module__jDiBjW__title",
  "toast": "Toaster-module__jDiBjW__toast",
});
